import * as routes from '../../constants/routes';
import * as strings from '../constants/strings';

export function nextPage(currentPage = null, state) {
  currentPage = currentPage || window.location.pathname;

  switch (currentPage) {
    case routes.WEB_APPOINTMENT_WHAT_TO_EXPECT_PAGE:
      return routes.WEB_APPOINTMENT_WHO_FOR_PAGE;

    case routes.WEB_APPOINTMENT_WHO_FOR_PAGE:
      return routes.WEB_APPOINTMENT_RECEIVED_CARE_PAGE;

    case routes.WEB_APPOINTMENT_RECEIVED_CARE_PAGE:
      // For state.forMe, null or undefined is not the same as false.
      if (state.forMe === false && typeof state.patientSeenRecently === "boolean") {
        return routes.WEB_APPOINTMENT_CONTACT_INFO_PAGE;
      }
      else if (state.forMe && state.patientSeenRecently === true) {
        return routes.WEB_APPOINTMENT_EXISTING_PATIENT_INFO_PAGE;
      }
      else if (state.forMe && state.patientSeenRecently === false) {
        return routes.WEB_APPOINTMENT_NEW_PATIENT_INFO_PAGE;
      }
      break;

    case routes.WEB_APPOINTMENT_CONTACT_INFO_PAGE:
      if (state.patientSeenRecently === true) {
        return routes.WEB_APPOINTMENT_EXISTING_PATIENT_INFO_PAGE;
      }
      else if (state.patientSeenRecently === false) {
        return routes.WEB_APPOINTMENT_NEW_PATIENT_INFO_PAGE;
      }
      break;

    case routes.WEB_APPOINTMENT_EXISTING_PATIENT_INFO_PAGE:
      return routes.WEB_APPOINTMENT_APPOINTMENT_INFO1_PAGE;

    case routes.WEB_APPOINTMENT_NEW_PATIENT_INFO_PAGE:
      return routes.WEB_APPOINTMENT_NEW_PATIENT_ADDRESS_PAGE;

    case routes.WEB_APPOINTMENT_NEW_PATIENT_ADDRESS_PAGE:
      return routes.WEB_APPOINTMENT_APPOINTMENT_INFO1_PAGE;

    case routes.WEB_APPOINTMENT_APPOINTMENT_INFO1_PAGE:
      return routes.WEB_APPOINTMENT_APPOINTMENT_INFO2_PAGE;

    case routes.WEB_APPOINTMENT_APPOINTMENT_INFO2_PAGE:
      return routes.WEB_APPOINTMENT_APPOINTMENT_PREFERENCES_PAGE;

    case routes.WEB_APPOINTMENT_APPOINTMENT_PREFERENCES_PAGE:
      return routes.WEB_APPOINTMENT_APPOINTMENT_INFO_PROVIDER;

    case routes.WEB_APPOINTMENT_APPOINTMENT_INFO_PROVIDER:
      return routes.WEB_APPOINTMENT_APPOINTMENT_INFO_DAY_TIME;

    case routes.WEB_APPOINTMENT_APPOINTMENT_INFO_DAY_TIME:
      return routes.WEB_APPOINTMENT_PAYMENT_METHOD;

    case routes.WEB_APPOINTMENT_PAYMENT_METHOD:
      if (state.paymentMethod && state.paymentMethod === "insurance") {
        return routes.WEB_APPOINTMENT_INSURANCE
      }
      else if (state.paymentMethod && state.paymentMethod === "out-of-pocket") {
        return routes.WEB_APPOINTMENT_OUT_OF_POCKET;
      }
      break;

    case routes.WEB_APPOINTMENT_INSURANCE:
      if (state.patientSeenRecently === true) {
        if (state.insurance.whereToSend === strings.TO_MY_ADDRESS) {
          if (state.forMe === true) {
            return routes.WEB_APPOINTMENT_REVIEW;
          }
          else {
            return routes.WEB_APPOINTMENT_BILLING_ADDRESS;
          }
        }
        else if (state.insurance.whereToSend === strings.TO_PATIENTS_ADDRESS) {
          return routes.WEB_APPOINTMENT_REVIEW;
        }
        else if (state.insurance.whereToSend === strings.SOMEWHERE_ELSE) {
          return routes.WEB_APPOINTMENT_BILLING_ADDRESS;
        }
      }
      else if (state.patientSeenRecently === false) {
          if (state.insurance.policyHolder.relation === strings.ME || state.insurance.policyHolder.relation === strings.THE_PATIENT) {
            return routes.WEB_APPOINTMENT_BILLING;
          }
          else if (typeof state.insurance.policyHolder.relation === "string" && state.insurance.policyHolder.relation.length > 0) {
            return routes.WEB_APPOINTMENT_POLICY_HOLDER;
          }
      }
      break;

    case routes.WEB_APPOINTMENT_BILLING:
      if (state.forMe) {
        if (state.insurance.whereToSend === strings.TO_MY_ADDRESS) {
          return routes.WEB_APPOINTMENT_REVIEW;
        }
        else if (state.insurance.whereToSend === strings.SOMEWHERE_ELSE) {
          return routes.WEB_APPOINTMENT_BILLING_ADDRESS;
        }
      }
      else if (state.forMe === false) {  // specifically false, as opposed to null or undefined.
        if (state.insurance.whereToSend === strings.TO_MY_ADDRESS || state.insurance.whereToSend === strings.SOMEWHERE_ELSE) {
          return routes.WEB_APPOINTMENT_BILLING_ADDRESS;
        }
        else if (state.insurance.whereToSend === strings.TO_PATIENTS_ADDRESS) {
          return routes.WEB_APPOINTMENT_REVIEW;
        }
      }
      break;

    case routes.WEB_APPOINTMENT_POLICY_HOLDER:
      return routes.WEB_APPOINTMENT_BILLING;

    case routes.WEB_APPOINTMENT_BILLING_ADDRESS:
      return routes.WEB_APPOINTMENT_REVIEW;

    case routes.WEB_APPOINTMENT_OUT_OF_POCKET:
      return routes.WEB_APPOINTMENT_REVIEW;

    case routes.WEB_APPOINTMENT_REVIEW:
      if (state.message){
        return routes.WEB_APPOINTMENT_ERROR_REVIEW;
      }
      if (state.paymentMethod === "out-of-pocket") {
        let isFlorida = state.appointment.location.includes("Florida");
        if (isFlorida) {
          return routes.WEB_APPOINTMENT_THANK_YOU_PFA;
        }
        else {
          return routes.WEB_APPOINTMENT_PFA_APPOINTMENT;
        }
      }
      else {
        return routes.WEB_APPOINTMENT_THANK_YOU_INSURANCE;
      }
      
    case routes.WEB_APPOINTMENT_PFA_APPOINTMENT:
      return routes.WEB_APPOINTMENT_THANK_YOU_PFA_APPT;

    case routes.WEB_APPOINTMENT_THANK_YOU_PFA_APPT:
      return routes.WEB_APPOINTMENT_WHO_FOR_PAGE;

    case routes.WEB_APPOINTMENT_THANK_YOU_PFA:
      return routes.WEB_APPOINTMENT_WHO_FOR_PAGE;

    case routes.WEB_APPOINTMENT_THANK_YOU_INSURANCE:
      return routes.WEB_APPOINTMENT_WHO_FOR_PAGE;
    
    case routes.WEB_APPOINTMENT_ERROR_REVIEW:
      if (state.message){
            // Redirect to the what to expect page
        return routes.WEB_APPOINTMENT_WHAT_TO_EXPECT_PAGE;
      }
      if (state.paymentMethod === "out-of-pocket") {
        let isFlorida = state.appointment.location.includes("Florida");
        if (isFlorida) {
          return routes.WEB_APPOINTMENT_THANK_YOU_PFA;
        }
        else {
          return routes.WEB_APPOINTMENT_PFA_APPOINTMENT;
        }
      }
      else {
        return routes.WEB_APPOINTMENT_THANK_YOU_INSURANCE;
      }  

    default:
      return currentPage;
  }
  return currentPage;
}
